import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import BankAccount from "./BankAccount";
import EmancipationCertificate from "./EmancipationCertificate";
import Id from "./Id";

const generateProofForm = ({ showEmancipationCertificate = false } = {}) => ({
  [SUBSCRIPTION_FORM_KEYS.PROOF.ID]: Id,
  [SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT]: BankAccount,
  ...(showEmancipationCertificate && {
    [SUBSCRIPTION_FORM_KEYS.PROOF.EMANCIPATION_CERTIFICATE]:
      EmancipationCertificate,
  }),
});

export default generateProofForm;
